
import { ExpandMore, MenuOpenOutlined, MenuOutlined } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../store/AppProvider';
import './Layout.css';
import { sideNavItemIcon, sideNavItems } from './Navigation';

export const Layout = ({ children }) => {
    const navigate = useNavigate()
    const location = useLocation();
    const { toggleNav, setToggleNav, route, setRoute, activeRole } = useContext(AppContext)
    const [expanded, setExpanded] = useState('panel1');

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    useEffect(() => {
        setRoute(location?.pathname);
        setExpanded(getPanelName(location?.pathname))
    }, [location.pathname, setRoute]);

    const getPanelName = (pathname) => {
        for (let i of sideNavItems) {
            if (i?.nestedItems?.length) {
                for (let j of i?.nestedItems) {
                    if (j?.subRoute === pathname) {
                        return i?.id;
                    }
                }
            } else if (i?.titleRoute === pathname) {
                return i?.id;
            }
        }
        return ''
    }

    const handleNonNestedItems = (titleRoute, nestedItems) => {
        !nestedItems?.length && navigate(titleRoute); setToggleNav(false);
    }

    const handleNestedItems = (subRoute) => {
        setTimeout(() => {
            setToggleNav(false);
        }, 0);
        setTimeout(() => {
            navigate(subRoute);
        }, 0);
    }

    return (
        <>
            <div id="mySidenav" className="sidenav" style={{ width: toggleNav ? 280 : 0 }}>
                {sideNavItems.map(({ id, title, titleIcon, titleRoute, nestedItems, role: titleRole }) =>
                    titleRole?.[activeRole]
                        ? <div key={`${id}_${title}`}>
                            {nestedItems?.length
                                ? <Accordion
                                    key={id}
                                    expanded={expanded === id}
                                    onChange={handleChange(id)}
                                    style={{ borderRadius: 0, backgroundColor: '#111', margin: 0 }}
                                    sx={{ '.css-eqpfi5-MuiAccordionSummary-content.Mui-expanded': { margin: '10px 0' } }}
                                >
                                    <AccordionSummary
                                        style={{ backgroundColor: nestedItems?.length ? '#2A2A2A' : '#111', color: 'white', minHeight: 0, }}
                                        expandIcon={nestedItems?.length ? <ExpandMore style={{ color: expanded === id ? '#fff' : '#818181', }} /> : ''}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                    >
                                        <Typography
                                            style={{
                                                justifyContent: 'flex-start',
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}
                                            variant='h6'
                                            sx={{ width: '100%', flexShrink: 0, fontSize: '1.1rem', fontWeight: 500, color: expanded === id ? '#fff' : '#818181' }}
                                            onClick={() => { !nestedItems?.length && navigate(titleRoute) }}
                                        >
                                            {sideNavItemIcon[titleIcon]}&nbsp;{title?.toUpperCase()}
                                        </Typography>
                                    </AccordionSummary>
                                    {nestedItems?.length &&
                                        <AccordionDetails style={{ marginLeft: 30, }}>
                                            {nestedItems?.map(({ subRouteId, subRouteTitle, subRoute, role, hidden }) => {
                                                return role?.[activeRole] && Boolean(!hidden) && <Typography
                                                    key={subRouteId}
                                                    style={{ color: route === subRoute ? '#fff' : '#818181', fontSize: route === subRoute && 17, cursor: 'pointer', paddingTop: 5, paddingBottom: 5 }}
                                                    onClick={() => handleNestedItems(subRoute)}>
                                                    {subRouteTitle}
                                                </Typography>
                                            }
                                            )}
                                        </AccordionDetails>}
                                </Accordion>
                                : <div
                                    key={id}
                                    className='div-accordion'
                                    style={{
                                        color: route === titleRoute ? '#fff' : '#818181',
                                    }}
                                    onClick={() => { handleNonNestedItems(titleRoute, nestedItems, titleRoute) }}
                                >{sideNavItemIcon[titleIcon]}&nbsp;{title?.toUpperCase()}
                                </div>}
                        </div>
                        : <div key={`${id}_${title}`} />
                )}
            </div >

            <div id="main" style={{ marginLeft: toggleNav ? 280 : 0 }}>
                <div style={{ marginTop: 70 }}>
                    <div style={{ cursor: 'pointer', position: 'absolute' }} onClick={() => setToggleNav(!toggleNav)}>
                        {toggleNav
                            ? <MenuOpenOutlined fontSize='large' />
                            : <MenuOutlined fontSize='large' />}
                    </div>
                    <Box sx={{ flexGrow: 1, paddingLeft: 7, paddingRight: 7 }}>
                        {children ? children : <Outlet />}
                    </Box>
                </div>
            </div>
        </>
    );
}
